import { useEffect } from "react";

interface MetaOptions {
  title: string;
  description: string;
  keywords?: string;
}

const setMeta = (name: string, content: string, attr: "name" | "property" = "name") => {
  let tag = document.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

export function useDocumentMeta({ title, description, keywords }: MetaOptions) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    if (keywords) {
      setMeta("keywords", keywords);
    }
  }, [title, description, keywords]);
}